import { render, staticRenderFns } from "./AddBuilding.vue?vue&type=template&id=5c92f12c&scoped=true&"
import script from "./AddBuilding.vue?vue&type=script&lang=js&"
export * from "./AddBuilding.vue?vue&type=script&lang=js&"
import style0 from "./AddBuilding.vue?vue&type=style&index=0&id=5c92f12c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92f12c",
  null
  
)

export default component.exports